import * as tslib_1 from "tslib";
import createInboxRuleFromStoreEditState from './helpers/createInboxRuleFromStoreEditState';
import newInboxRuleAction from './newInboxRuleAction';
import setInboxRuleAction from './setInboxRuleAction';
import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import resetInboxRuleEdit from './resetInboxRuleEdit';
import getInboxRules from './getInboxRules';
export default action('saveInboxRuleEdit')(select({
    optionState: function () { return store; },
})(function saveInboxRuleEdit(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var inboxRuleId, inboxRule;
        return tslib_1.__generator(this, function (_a) {
            inboxRuleId = state.optionState.inboxRulesEditState.ruleId;
            inboxRule = createInboxRuleFromStoreEditState(inboxRuleId);
            // If the rule already has an id, that means it is an edited rule
            if (inboxRuleId) {
                return [2 /*return*/, setInboxRuleAction(inboxRule, store.inboxRulesEditState.shouldRunRuleNow)];
            }
            else {
                // no-op if the user is saving an unmodified rule
                return [2 /*return*/, newInboxRuleAction(inboxRule, 'RuleOption', onSaveSuccess, function () { return Promise.resolve(); }, store.inboxRulesEditState.shouldRunRuleNow)];
            }
            return [2 /*return*/];
        });
    });
}));
function onSaveSuccess() {
    resetInboxRuleEdit();
    // re-fetch the rules list if successful
    getInboxRules();
    return Promise.resolve();
}
//# sourceMappingURL=saveInboxRuleEdit.js.map